import {useCustomQuery} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {supplierRegistrySummaryUrl} from "../services/supplier360Urls";
import type {SupplierRegistrySummary} from "../types/Supplier360Types";

/**
 * The registry's KPI strip (`GET supplier_360/entity/registry_summary/?databag_id=`).
 * Databag-wide totals, so it is deliberately independent of the tables' search/filter state.
 */
export function useSupplierRegistrySummaryQuery(databagId: number) {
    const url = supplierRegistrySummaryUrl(databagId);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierRegistrySummary>(url)).data,
        enabled: Boolean(databagId),
    });
}
